import React, { useEffect } from 'react';

const getPromiseWithResolvers = () => {
  let resolve: (value?: unknown) => void;
  let reject: (reason?: any) => void;
  const promise = new Promise((_resolve, _reject) => {
    resolve = _resolve;
    reject = _reject;
  });
  return {
    promise,
    // @ts-expect-error I know what I'm doing
    resolve,
    // @ts-expect-error I know what I'm doing
    reject,
  };
};

export const useCBQueue = <
  CB extends (data: any) => Promise<any>,
  Data = Parameters<CB>[0],
  ResponseData = Awaited<ReturnType<CB>>,
>(
  cb: CB,
  isReady: boolean,
) => {
  const ref = React.useRef<{
     
    resolve: (data: ResponseData) => void;
    data: Data;
  } | null>(null);

  useEffect(() => {
    if (isReady && ref.current) {
      cb(ref.current?.data).then((data: ResponseData) => {
        ref.current?.resolve(data);
        ref.current = null;
      });
    }
  }, [isReady, cb]);

  return React.useCallback(
    (data: Data) => {
      if (isReady) {
        return cb(data);
      }
      const { promise, resolve } = getPromiseWithResolvers();
      ref.current = { resolve, data };
      return promise as Promise<ResponseData>;
    },
    [isReady, cb],
  );
};
